<form [formGroup]="data" class="register-carrier-form py-5">

  <h2 class="text-center">{{ invite ? "Register" : "Requested changes" }}</h2>

  <h5 *ngIf="invite" class="text-center mt-5">Create a new account</h5>

  <div class="row g-3">
    <div class="col-12 col-sm-6">
      <mat-form-field>
        <input formControlName="name" type="text" matInput placeholder="Business Name"
          (ngModelChange)="formValidator('name')" />
      </mat-form-field>
      <div *ngIf="errors && errors.name" class="register--error">
        Business Name is required.
      </div>
    </div>
    <div class="col-12 col-sm-6">
      <mat-form-field>
        <input type="text" placeholder="Address" aria-label="Address" matInput formControlName="address"
          [matAutocomplete]="addressLocationAuto" />
        <mat-autocomplete (optionSelected)="addressValidator($event.option.value)"
          [displayWith]="displayAddressOption"
          #addressLocationAuto="matAutocomplete">
          <mat-option *ngFor="let option of addressLocationOptions$ | async" [value]="option">
            {{ option.label }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <div *ngIf="errors && errors.address" class="register--error">
        Address is required.
      </div>
      <div *ngIf="errors && (errors.city || errors.state || errors.zip)" class="register--error">
        Please select a valid full US address.
      </div>
    </div>
  </div>

  <div class="row g-3">
    <div class="col-6 col-sm-6">
      <mat-form-field>
        <input formControlName="dotNumber" type="number" matInput placeholder="DOT Number"
          (ngModelChange)="formValidator('dotNumber')" />
      </mat-form-field>

      <div *ngIf="errors && errors.dotNumber" class="register--error">
        DOT Number is required.
      </div>
    </div>
    <div class="col-6 col-sm-6">
      <mat-form-field>
        <input formControlName="msNumber" type="number" matInput placeholder="MS Number"
          (ngModelChange)="formValidator('msNumber')" />
      </mat-form-field>

      <div *ngIf="errors && errors.msNumber" class="register--error">
        MS Number is required.
      </div>
    </div>
  </div>

  <div class="row g-3">
    <div class="col-12 col-sm-6">
      <mat-form-field>
        <input formControlName="officePhone" type="tel" matInput placeholder="Office Phone"
          (ngModelChange)="formValidator('officePhone')" />
      </mat-form-field>

      <div *ngIf="errors && errors.officePhone" class="register--error">
        Office Phone is required.
      </div>
    </div>
    <div class="col-12 col-sm-6">
      <mat-form-field>
        <input formControlName="email" type="email" matInput placeholder="Email"
          (ngModelChange)="formValidator('email')" />
      </mat-form-field>

      <div *ngIf="errors && errors.email" class="register--error">
        Email is required.
      </div>
    </div>
  </div>
  <div class="row g-3">
    <div class="col-12">
      <mat-form-field>
        <input formControlName="contactPersonPhone" type="tel" matInput
          placeholder="Contact Person Phone (not required)" />
      </mat-form-field>
    </div>
  </div>

  <div class="row g-3">
    <div class="col-6 col-sm-6">
      <mat-form-field>
        <input formControlName="contactPersonFirstName" type="text" matInput placeholder="Contact Person First Name"
          (ngModelChange)="formValidator('contactPersonFirstName')" />
      </mat-form-field>

      <div *ngIf="errors && errors.contactPersonFirstName" class="register--error">
        Contact Person First Name is required.
      </div>
    </div>
    <div class="col-6 col-sm-6">
      <mat-form-field>
        <input formControlName="contactPersonLastName" type="text" matInput placeholder="Contact Person Last Name"
          (ngModelChange)="formValidator('contactPersonLastName')" />
      </mat-form-field>

      <div *ngIf="errors && errors.contactPersonLastName" class="register--error">
        Contact Person Last Name is required.
      </div>
    </div>
  </div>


  <div class="row g-3">
    <div class="col-12 col-sm-6">

      <div class="document register__form--file-picker flex flex--row flex__align-items--center p-2">
        <mat-icon>note_add</mat-icon>
        <span textSize="13" textColor="brownish-grey" class="flex--box register__form--file">{{ mcCertificate ?
          mcCertificate.url : "Add Mc Certificate" }}</span>
        <input #mcCertificateDoc accept="image/jpeg,application/pdf"
          (change)="selectMcCertificate($event.target.files[0])" id="mcCertificate" type="file"
          placeholder="Add Mc Certificate" hidden />
        <label textSize="16" textColor="dodger-blue" class="block--click link-color" for="mcCertificate">Browse</label>
      </div>
      <div *ngIf="errors && errors.mcCertificate" class="register--errors mt-1">
        Mc Certificate is required.
      </div>
    </div>

    <div class="col-12 col-sm-6">
      <div class="document register__form--file-picker flex flex--row flex__align-items--center p-2">
        <mat-icon>security</mat-icon>
        <span textSize="13" textColor="brownish-grey" class="flex--box register__form--file">{{ insurance ?
          insurance.url : "Add Insurance" }}</span>
        <input #insuranceDoc accept="image/jpeg,application/pdf" (change)="selectInsurance($event.target.files[0])"
          id="insurance" type="file" placeholder="Add Mc Certificate" hidden />
        <label textSize="16" class="block--click link-color" for="insurance">Browse</label>
      </div>

      <div *ngIf="errors && errors.insurance" class="register--errors mt-1">
        Insurance is required.
      </div>
    </div>
  </div>

  <div class="row g-3">
    <div class="col-12 col-sm-6 terms-of-service">
      <mat-checkbox color="primary" [required]="true" formControlName="terms" class="register__form--checkbox"
        (ngModelChange)="formValidator('terms')" ngDefaultControl>
        <span textSize="13" (click)="openTermService()">Agree with terms of service</span>
      </mat-checkbox>

      <div *ngIf="errors && errors.terms" class="register--error mt-1">
        Terms is required.
      </div>
    </div>
    <div class="col-12 col-sm-6 ">
      <button type="button" [disabled]="data.invalid" (click)="checkRegister()" class="register__form--button" mat-raised-button
        color="primary">
        Sign Up
      </button>
      <p textSize="13" class="text--center">
        Already Registered?
        <span textSize="14" class="block--click link-color" (click)="login()">Sign In</span>
      </p>
    </div>
  </div>
</form>
